function scrollToEl(el) {
    var scrollDuration = 300;

    var items = [
        $('#debug-bar'),
        $('#admin-bar'),
        $('.notice-bar')
    ];
    var scrollTop = Math.round(el.offset().top - 10);

    for (var i = 0; i < items.length; i++) {
        if (items[i].length > 0) {
            scrollTop -= items[i].outerHeight();
        }
    }

    $('html, body').animate({
        scrollTop: scrollTop
    }, {
        duration: scrollDuration
    });
}